export const toNumber = (x: string | null, backup: number): number => {
  if (x === null) return backup
  if (isNaN(Number(x))) return backup
  return Number(x)
}

export const toBoolean = (x: string | null, backup: boolean): boolean => {
  if (x === null) return backup
  if (x === "true") return true
  if (x === "false") return false
  return backup
}

export const splitArrayAt = <T>(index: number, array?: T[]): T[][] => [
  array?.slice(0, index) || [],
  array?.slice(index, array?.length) || [],
]

// (a → Boolean) → [a] → Boolean
export function all<T>(pred: (x: T) => boolean, list: T[]): boolean {
  return list.every(pred)
}

export function extractContent(html: string) {
  return new DOMParser().parseFromString(html, "text/html").documentElement
    .textContent
}
